import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import type {
    CommandContribution,
    CommandRegistry,
} from '@patsnap/tahiti-core';
import type {
    HubspotDialogResult,
} from '@/presentation/components/hubspot/HubspotDialog.vue';
import { hubspotDialogServiceFactory } from '../hubspot-dialog.service';
import { HUBSPOT_CONFIG } from '../hubspot-config';

/**
 * HubSpot 对话框命令处理器
 */
@injectable()
export class HubspotDialogCommandHandler implements CommandContribution {
    private _dialogService = hubspotDialogServiceFactory();

    /**
     * 处理打开联系我们对话框命令
     */
    private async _handleContactUs(payload?: { title?: string }): Promise<HubspotDialogResult> {
        return new Promise((resolve, reject) => {
            const dialog = this._dialogService;

            // 设置提交回调
            dialog.onSubmit(async (result, next) => {
                try {
                    // 可以在这里添加提交后的处理逻辑
                    // 例如：埋点、数据分析等
                    console.log('HubSpot form submitted:', result);
                    resolve(result);
                    next(); // 关闭对话框
                } catch (error) {
                    next(false); // 保持对话框打开
                    reject(error);
                }
            });

            // 设置取消回调
            dialog.onCancel(() => {
                const result: HubspotDialogResult = {
                    action: 'cancel',
                };
                resolve(result);
            });

            // 打开对话框，使用配置文件的默认值
            dialog.open({
                title: payload?.title,
                portalId: HUBSPOT_CONFIG.PORTAL_ID,
                formId: HUBSPOT_CONFIG.FORM_ID,
                region: HUBSPOT_CONFIG.REGION,
            });
        });
    }


    /**
     * 注册命令
     */
    registerCommands(commands: CommandRegistry): void {
        // 注册联系我们命令
        commands.registerCommand({
            id: 'hubspot:contact-us',
        }, {
            execute: (payload?: { title?: string }) => {
                return this._handleContactUs(payload);
            },
        });
    }
}
